import axios from "axios";

export function submitGoodItem(good) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.API_URL+'/good',JSON.stringify(good), {
      headers: {
        'Content-Type': 'application/json',
      }

    })
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(err){
        reject(err);
      })
  })

}
export function deleteGoodItem(id) {
  return new Promise(function(resolve, reject) {
    axios.delete(process.env.API_URL+'/good?id='+id, {
      headers: {
        'Content-Type': 'application/json',
      }

    })
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(err){
        reject(err);
      })
  })

}
export function getGoodsTemplates(type, orderBy = null) {
  return new Promise(function(resolve, reject) {
    let url = process.env.API_URL+'/goods/templates?type='+type;
    if(orderBy != null) {
      url += '&orderBy=' + orderBy;
    }
    axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
      }

    })
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(err){
        reject(err);
      })
  })

}
export function getLocationList() {
  let list = [
    {
      title:'Living Room',
      value:'Living Room',
    },
    {
      title:'Dining Room',
      value:'Dining Room',
    },
    {
      title:'Kitchen',
      value:'Kitchen',
    },
    {
      title:'Master Bed Room',
      value:'Master Bed Room',
    },
    {
      title:'Room1',
      value:'Room1',
    },
    {
      title:'Room2',
      value:'Room2',
    },
    {
      title:'Room3',
      value:'Room3',
    },
    {
      title:'Garage',
      value:'Garage',
    },
    {
      title:'Others',
      value:'Others',
    }
  ];
  return list;
}
export function getGoodSizeList() {
  let list = [
    {
      title: 'Small',
      value: 'small',
    },
    {
      title: 'Medium',
      value: 'medium',
    },
    {
      title: 'Large',
      value: 'large',
    },
  ];

  return list;
}



// WEBPACK FOOTER //
// ./src/api/goods.js